import { Html5Qrcode, Html5QrcodeResult, Html5QrcodeScanner } from 'html5-qrcode';
import { useEffect, useRef } from 'react';
import { createConfig } from './util';

const qrcodeRegionId = 'barcode-scanner-full-region';

export interface BarcodeScannerProps {
  onSuccessfullScan: (
    newDecodedText: string,
    newDecodedResult: Html5QrcodeResult
  ) => void;
}

const BarcodeScanner = (props: BarcodeScannerProps) => {
  const scannerRef = useRef<Html5QrcodeScanner | null>(null);
  const lastScannedRef = useRef<{ text: string; timestamp: number }>({
    text: '',
    timestamp: 0,
  });

  const config = createConfig();
  const COOLDOWN_TIME = 2000; // 2 seconds

  const handleScan = (newDecodedText: string, newDecodedResult: Html5QrcodeResult) => {
    const now = Date.now();

    // Check if the same scan result is received within the cooldown period
    if (newDecodedText === lastScannedRef.current.text && now - lastScannedRef.current.timestamp < COOLDOWN_TIME) {
      return; // Ignore repeated scan within cooldown
    }

    // Update last scanned data
    lastScannedRef.current = { text: newDecodedText, timestamp: now };

    // Call the original handler
    props.onSuccessfullScan(newDecodedText, newDecodedResult);
  };

  useEffect(() => {
    scannerRef.current = new Html5QrcodeScanner(
      qrcodeRegionId,
      { ...config, showTorchButtonIfSupported: true, showZoomSliderIfSupported: true },
      false
    );

    if (scannerRef.current) {
      scannerRef.current.render(handleScan, undefined);
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear();
      }
    };
  }, []);

  return <div id={qrcodeRegionId} />;
};

export default BarcodeScanner;
